import React from 'react'

function GetQuote() {
  return (
    <div>GetQuote</div>
  )
}

export default GetQuote